import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { Accordion } from "@itandi/itandi-bb-ui/Accordion";
import type React from "react";
import Styles from "./AccordionHtml.module.scss";

type Props = DeepReadonly<{
	html: string;
	maxHeightForClosed: number;
}>;

export const AccordionHtml: React.FC<Props> = ({
	html,
	maxHeightForClosed
}: Props) => (
	<Accordion maxHeightForClosed={maxHeightForClosed}>
		<div
			className={Styles.HtmlContent}
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	</Accordion>
);
